// src/components/summarized-reviews/summarized-reviews.tsx
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment SummarizedReviewsContentListFragment on ProductAmenitiesSection {\n    list {\n      __typename\n      ... on EGDSBulletedList {\n        __typename\n        listItems {\n          ... on EGDSTextStandardListItem {\n            __typename\n            text\n          }\n        }\n      }\n    }\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment SummarizedReviewsContentFragment on ReviewSummaryInfo {\n    __typename\n    content {\n      ... on ProductAmenitiesSection {\n        title {\n          __typename\n          text\n        }\n        ...SummarizedReviewsContentListFragment\n      }\n    }\n    impressionAnalytics {\n      __typename\n      referrerId\n      linkName\n    }\n  }\n  ", "\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment SummarizedReviewsDisclaimerFragment on EGDSGraphicText {\n    __typename\n    text\n    graphic {\n      ... on Icon {\n        __typename\n        title\n        token\n        id\n        description\n      }\n    }\n  }\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  query SummarizedReviewsQuery($context: ContextInput!, $productIdentifier: ProductIdentifierInput!) {\n    productReviewSummary(context: $context, productIdentifier: $productIdentifier) {\n      summary {\n        ...SummarizedReviewsContentFragment\n      }\n      disclaimer {\n        ...SummarizedReviewsDisclaimerFragment\n      }\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
import React4 from "react";
import { gql as gql4, useQuery } from "@apollo/client";
import { EGDSCard } from "@egds/react-core/cards";
import { EGDSLayoutFlex } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { useBexApi } from "@shared-ui/bex-api-context";
// src/components/summarized-reviews/__private/__fragments/summarized-reviews-content.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { EGDSCardContentSection } from "@egds/react-core/cards";
import { EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSHeading } from "@egds/react-core/text";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";
// src/components/summarized-reviews/__private/__fragments/summarized-reviews-content-list.tsx
import React from "react";
import { gql } from "@apollo/client";
import { EGDSList, EGDSListItem } from "@egds/react-core/list";
var fragment = gql(_templateObject());
var SummarizedReviewsContentList = function (param) {
  var data = param.data;
  var _list;
  var list = data.list;
  switch ((_list = list) === null || _list === void 0 ? void 0 : _list.__typename) {
    case "EGDSBulletedList":
      return /* @__PURE__ */React.createElement(EGDSList, {
        spacing: true
      }, list.listItems.map(function (listItem, listIndex) {
        var _listItem, _listItem1;
        return /* @__PURE__ */React.createElement(EGDSListItem, {
          key: listIndex
        }, ((_listItem = listItem) === null || _listItem === void 0 ? void 0 : _listItem.__typename) === "EGDSTextStandardListItem" && ((_listItem1 = listItem) === null || _listItem1 === void 0 ? void 0 : _listItem1.text));
      }));
    default:
      return null;
  }
};
SummarizedReviewsContentList.fragment = fragment;
SummarizedReviewsContentList.displayName = "SummarizedReviewsContentList";
// src/components/summarized-reviews/__private/__fragments/summarized-reviews-content.tsx
var fragment2 = gql2(_templateObject1(), SummarizedReviewsContentList.fragment);
var SummarizedReviewsContent = function (param) {
  var data = param.data;
  var _content, _impressionAnalytics, _impressionAnalytics1, _content_title, _content1;
  var content = data.content,
    impressionAnalytics = data.impressionAnalytics;
  if (!((_content = content) === null || _content === void 0 ? void 0 : _content.list)) {
    return null;
  }
  var impressionReferrerId = ((_impressionAnalytics = impressionAnalytics) === null || _impressionAnalytics === void 0 ? void 0 : _impressionAnalytics.referrerId) || "";
  var impressionLinkName = ((_impressionAnalytics1 = impressionAnalytics) === null || _impressionAnalytics1 === void 0 ? void 0 : _impressionAnalytics1.linkName) || "";
  return /* @__PURE__ */React2.createElement(IntersectionTracker, {
    trackOnce: true,
    referrerId: impressionReferrerId,
    linkName: impressionLinkName
  }, /* @__PURE__ */React2.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React2.createElement(EGDSCardContentSection, {
    padded: false
  }, /* @__PURE__ */React2.createElement(EGDSHeading, {
    tag: "h3",
    size: 7
  }, (_content1 = content) === null || _content1 === void 0 ? void 0 : (_content_title = _content1.title) === null || _content_title === void 0 ? void 0 : _content_title.text), /* @__PURE__ */React2.createElement(SummarizedReviewsContentList, {
    data: content
  }))));
};
SummarizedReviewsContent.fragment = fragment2;
SummarizedReviewsContent.displayName = "SummarizedReviewsContent";
// src/components/summarized-reviews/__private/__fragments/summarized-reviews-disclaimer.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSText } from "@egds/react-core/text";
var fragment3 = gql3(_templateObject2());
var SummarizedReviewsDisclaimer = function (param) {
  var data = param.data;
  var _graphic;
  var text = data.text,
    graphic = data.graphic;
  if (!text) {
    return null;
  }
  return /* @__PURE__ */React3.createElement("div", null, ((_graphic = graphic) === null || _graphic === void 0 ? void 0 : _graphic.__typename) === "Icon" && /* @__PURE__ */React3.createElement(EGDSSpacing, {
    padding: {
      inlineend: "one"
    }
  }, /* @__PURE__ */React3.createElement(EGDSIcon, {
    title: graphic.description,
    description: graphic.description,
    id: graphic.id,
    name: graphic.token,
    size: EGDSIconSize.EXTRA_SMALL
  })), /* @__PURE__ */React3.createElement(EGDSText, {
    size: 100,
    inline: !!text
  }, text));
};
SummarizedReviewsDisclaimer.fragment = fragment3;
SummarizedReviewsDisclaimer.displayName = "SummarizedReviewsDisclaimer";
// src/components/summarized-reviews/summarized-reviews.tsx
var __Query = gql4(_templateObject3(), SummarizedReviewsContent.fragment, SummarizedReviewsDisclaimer.fragment);
var SummarizedReviews = function (param) {
  var inputs = param.inputs,
    skipSsr = param.skipSsr,
    batchKey = param.batchKey;
  var _data, _summary;
  var context = useBexApi().context;
  var DEFAULT_BATCH_KEY = "default-product-details-experience-batch-key";
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var _useQuery = useQuery(__Query, {
      context: {
        useApq: true,
        batchKey: batchKey !== null && batchKey !== void 0 ? batchKey : DEFAULT_BATCH_KEY
      },
      variables: variables,
      ssr: !skipSsr
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  if (loading || error || !data || !data.productReviewSummary) {
    return null;
  }
  var _ref = ((_data = data) === null || _data === void 0 ? void 0 : _data.productReviewSummary) || {},
    summary = _ref.summary,
    disclaimer = _ref.disclaimer;
  if (!summary) {
    return null;
  }
  return /* @__PURE__ */React4.createElement("div", {
    "data-stid": "product-summarized-reviews"
  }, /* @__PURE__ */React4.createElement(EGDSSpacing2, {
    margin: {
      blockstart: "two",
      blockend: "three"
    }
  }, /* @__PURE__ */React4.createElement(EGDSCard, {
    backgroundTheme: "secondary"
  }, /* @__PURE__ */React4.createElement(EGDSSpacing2, {
    padding: "four"
  }, /* @__PURE__ */React4.createElement(EGDSLayoutFlex, {
    space: "three",
    direction: "column"
  }, (_summary = summary) === null || _summary === void 0 ? void 0 : _summary.map(function (item, index) {
    return /* @__PURE__ */React4.createElement(SummarizedReviewsContent, {
      data: item,
      key: index
    });
  }), disclaimer && /* @__PURE__ */React4.createElement(SummarizedReviewsDisclaimer, {
    data: disclaimer
  }))))));
};
SummarizedReviews.displayName = "sharedui-SummarizedReviews";
// src/__generated__/types.ts
var IdentifierType = /* @__PURE__ */function (IdentifierType2) {
  IdentifierType2["ACTIVITY_ID"] = "ACTIVITY_ID";
  IdentifierType2["CART_ID"] = "CART_ID";
  IdentifierType2["CHECKOUT_SESSION_ID"] = "CHECKOUT_SESSION_ID";
  IdentifierType2["ENTITY_ID"] = "ENTITY_ID";
  IdentifierType2["LEGACY_ORDER_ID"] = "LEGACY_ORDER_ID";
  IdentifierType2["OFFER_ID"] = "OFFER_ID";
  IdentifierType2["ORDER_ID"] = "ORDER_ID";
  IdentifierType2["PROPERTY_ID"] = "PROPERTY_ID";
  return IdentifierType2;
}(IdentifierType || {});
export { IdentifierType, SummarizedReviews };